import { BackendURL } from "../globals";
import API from "../api";
import { ApiError, OpenAPI } from "../_generated";

// get token from params and reload page without the token
let url = new URL(window.location.href);
const token = url.searchParams.get("token");
const cliCallback = url.searchParams.get("cli_callback");
if (token) {
  localStorage.setItem("authToken", token);
  url.searchParams.delete("token");
  window.location.replace(url.href);
}
if (cliCallback) {
  url.searchParams.delete("cli_callback");
  window.location.href = `${cliCallback}?token=${token}&redirect_uri=${url.href}`;
}

export const authToken = localStorage.getItem("authToken");
OpenAPI.TOKEN = authToken ?? undefined;
if (authToken) {
  // preload profile
  API.profile.read();
}

export function logout() {
  if (authToken) {
    localStorage.removeItem("authToken");
    OpenAPI.TOKEN = undefined;
    window.location.reload();
  }
}

export function login() {
  window.location.href = `${BackendURL}/login/github/?redirect_uri=${window.location.href}`;
}

export interface UserProfile {
  pk: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  avatar_url: string;
}

export async function fetchProfile(): Promise<UserProfile> {
  const url = `${BackendURL}/users/profile`;
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  if (response.status >= 400) {
    throw new ApiError(response, response.statusText);
  }
  return await response.json();
}
